/** @format */

import {ValidCheck} from '../model';

const getTotalAndTotalNew = (
  checks: ValidCheck[],
  ids: string[],
): {totalNew: number; total: number} => {
  return checks.reduce(
    (acc, cur) => {
      if (ids.includes(cur.sensor.name)) {
        return {
          total: acc.total + cur.found,
          totalNew: acc.totalNew + cur.new,
        };
      }
      return acc;
    },
    {total: 0, totalNew: 0},
  );
};

export {getTotalAndTotalNew};
